import { gql } from '@apollo/client';

export const UPDATE_SALES_ORDER = gql`
  mutation updateSalesOrder($input: UpdateSalesOrderInput!) {
    updateSalesOrder(input: $input) {
      uid
      creditCardId
      renewal
      isRenewalDisabled
      scheduledTerminationDate
      orderStatus
      paymentState
      attachments {
        uid
        fileName
        mimeType
        sizeBytes
      }
      orderLines {
        orderLineId
        version
        salesOrderId
        salesOrderStatus
        salesOrderPaymentState
        registrationPlates {
          plateText
          countryCode
        }
        validity {
          validFrom
          validTo
        }
        charge {
          uid
          salesOrderUid
          orderLineId
          validity {
            validFrom
            validTo
          }
          creditCardEvents {
            content {
              created
            }
          }
        }
      }
    }
  }
`;
